<template>
  <div>
    <c-tab
      ref="nearmissTab"
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :height="tabHeight"
      :dense="true"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :count="count"
          @changeStatus="changeStatus"
          @closePopup="closePopup"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
      <!-- class="full-height" -->
</template>

<script>
export default {
  name: 'near-accident-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      splitter: 5,
      tab: 'nearRegisterTab',
      count: 0,
      addTabItems: [],
      tabItems: [],
    };
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.tabItems = [
        { name: 'nearRegisterTab', icon: 'edit', label: '아차사고 정보', component: () => import(`${'./nearRegisterTab.vue'}`) },
      ];
      this.addTabItems = [
        { name: 'accidentCausePrevention', icon: 'auto_fix_normal', label: '방지 및 감소대책', component: () => import(`${'./nearCausePrevention.vue'}`) },
      ];
      if (this.popupParam.iimAccidentId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    changeStatus() {
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    transInfo(data) {
      this.popupParam.iimAccidentId = data.iimAccidentId;
    },
    tabClick() {
      this.count++;
    },
  }
};
</script>
